import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var TableAdd = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 28 28"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6.75A3.75 3.75 0 0 1 6.75 3h14.5A3.75 3.75 0 0 1 25 6.75v7.75a7.49 7.49 0 0 0-1.5-.88V11h-5v2.27c-.53.14-1.03.35-1.5.6V11h-6v6h2.87c-.25.47-.46.97-.6 1.5H11v5h2.62c.24.54.53 1.04.88 1.5H6.75A3.75 3.75 0 0 1 3 21.25V6.75ZM4.5 18.5v2.75c0 1.24 1 2.25 2.25 2.25H9.5v-5h-5Zm5-1.5v-6h-5v6h5Zm14-10.25c0-1.24-1-2.25-2.25-2.25H18.5v5h5V6.75ZM17 4.5h-6v5h6v-5Zm-7.5 0H6.75c-1.24 0-2.25 1-2.25 2.25V9.5h5v-5Zm17.5 16a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-6-4a.5.5 0 0 0-1 0V20h-3.5a.5.5 0 0 0 0 1H20v3.5a.5.5 0 0 0 1 0V21h3.5a.5.5 0 0 0 0-1H21v-3.5Z"
  }));
});
TableAdd.displayName = 'TableAdd';
export var TableAddDimensions = {
  height: 28,
  width: 28
};